import { Suspense } from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { useStores } from '@/hooks/useStores';
import { lazyRoute } from '@/routing/lazyRoute';
import { readExampleJoined } from './exampleJoined';

const ExampleWorkAreaBanner = lazyRoute(
  () => import('./ExampleWorkAreaBanner'),
  (module) => module.ExampleWorkAreaBanner,
);

const ExampleJoinedNotice = lazyRoute(
  () => import('./ExampleJoinedNotice'),
  (module) => module.ExampleJoinedNotice,
);

/**
 * F-0704, EXA-11: where `ExampleWorkAreaBanner` mounts (`Layout.tsx`), loaded only in a work area
 * installed from an example, so the launch carries neither the banner nor the `examples` words. EXA-8:
 * also where the notice of a Join that has just landed here mounts, whatever the work area is.
 */
export const ExampleWorkAreaBannerSlot = observer(function ExampleWorkAreaBannerSlot({
  workAreaId,
}: {
  workAreaId: string | null | undefined;
}) {
  const { projectStore } = useStores();
  const location = useLocation();
  const project = workAreaId ? projectStore.projectMap[workAreaId] : undefined;
  const joined = readExampleJoined(location.state) !== null;
  if (!project?.examplePackageKey && !joined) return null;
  return (
    <Suspense fallback={null}>
      {project?.examplePackageKey && <ExampleWorkAreaBanner workAreaId={workAreaId} />}
      {joined && <ExampleJoinedNotice />}
    </Suspense>
  );
});
